import { getMappings } from '@@modules/admin/api/bohelp';
import { requestBrowserStorage } from './browserstorage';
import { Entities } from '@inwink/entities/entities';

// eslint-disable-next-line import/no-mutable-exports
export let helpMappingData;

export function openHelpMapping(version) {
    return new Promise<void>((resolve, reject) => {
        requestBrowserStorage("helpmappingv2").then((browserstorage) => {
            helpMappingData = browserstorage;
            helpMappingData.openData("helpmappingsv2", version);
            resolve();
        }).catch((err) => {
            reject(err);
        });
    });
    // helpMappingData = new BrowserStorage("helpmapping");
    // helpMappingData.openData("helpmappings", version);
}

export function clearHelpData(languageCode: any) {
    helpMappingData.set(languageCode, null);
    helpMappingData.set("lastupdated-" + languageCode, null);
    helpMappingData.set(languageCode, null);
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function syncMappings(languageCode: any, _srcmappings: any, force = false) {
    //return Promise.resolve({});
    return helpMappingData.get("lastupdated-" + languageCode).then((date: string) => {
        let lastupdated: string;
        let lastUpdatedDate: Date;
        if (!force && date) {
            lastupdated = date;
            lastUpdatedDate = new Date(date);
        }

        return getMappings(languageCode, lastupdated).then((mappings: Entities.IHelpMapping[]) => {
            const srcmappings = Object.assign({}, _srcmappings);
            if (mappings && mappings.length) {
                lastUpdatedDate = lastUpdatedDate || new Date(2000, 1, 1);
                mappings.forEach((t) => {
                    if (t.tinyUrl?.startsWith("/")){
                        t.tinyUrl = t.tinyUrl.substring(1);
                    }
                    srcmappings[t.featureCode] = t.tinyUrl;
                    const d = new Date(t.lastUpdate);
                    if (d > lastUpdatedDate) {
                        lastupdated = t.lastUpdate;
                        lastUpdatedDate = d;
                    }
                });
                helpMappingData.set(languageCode, JSON.stringify(srcmappings));
                helpMappingData.set("lastupdated-" + languageCode, lastupdated);
            }
            return srcmappings;
        }).then(null, (err) => {
            console.error(err);
            return {};
        });
    });
}
